// Google Analytics 4 event tracking helper

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

type GAEvent = {
  action: string;
  category: string;
  label?: string;
  value?: number;
};

export const trackEvent = ({ action, category, label, value }: GAEvent) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};

// Pre-defined events
export const analytics = {
  contactFormSubmit: (projectType?: string) =>
    trackEvent({ action: "form_submit", category: "contact", label: projectType || "non spécifié" }),

  roomPhotoSubmit: () =>
    trackEvent({ action: "form_submit", category: "room_photo", label: "3 conseils offerts" }),

  roomButtonClick: () =>
    trackEvent({ action: "cta_click", category: "room_photo", label: "floating_button" }),

  ctaClick: (label: string) =>
    trackEvent({ action: "cta_click", category: "navigation", label }),

  projectView: (slug: string) =>
    trackEvent({ action: "page_view", category: "project", label: slug }),

  blogPostView: (slug: string) =>
    trackEvent({ action: "page_view", category: "blog", label: slug }),

  socialClick: (platform: string) =>
    trackEvent({ action: "social_click", category: "outbound", label: platform }),

  navClick: (page: string) =>
    trackEvent({ action: "nav_click", category: "navigation", label: page }),
};
